import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { DEFAULT_ITEM_CLASSIFICATION_SCHEME_ID } from "../../constants/defaults";
import { get } from "lodash";
import { useSelector } from "react-redux";
import { getItemClassificationSchemeOptions } from "../../api/codelist/codeListsSlice";

const ItemClassificationSchemeIDSelect = ({
  name,
  label = "Item Classification Scheme ID",
  control,
  errors,
  readOnly = false,
  helperText,
  onChange,
  allowedCodes,
}) => {
  const itemClassificationSchemeOptions = (
    useSelector(getItemClassificationSchemeOptions) || []
  ).filter((option) => {
    if (!allowedCodes || allowedCodes.length === 0) {
      return true;
    }

    return allowedCodes.includes(option.code);
  });
  const getItemClassificationSchemeByCode = (code) => {
    return itemClassificationSchemeOptions.find((c) => c.code === code);
  };

  const errorMessage = get(errors, name, {})?.message;
  const combinedHelperText = [helperText, errorMessage]
    .filter(Boolean)
    .join(" * ");

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const selectedItemType =
          getItemClassificationSchemeByCode(field.value) ??
          getItemClassificationSchemeByCode(
            DEFAULT_ITEM_CLASSIFICATION_SCHEME_ID,
          ) ??
          null;
        return (
          <Autocomplete
            options={itemClassificationSchemeOptions}
            getOptionLabel={(option) => option.code}
            isOptionEqualToValue={(option, value) =>
              option.code === value?.code
            }
            filterOptions={(options, { inputValue }) => {
              const q = inputValue.trim().toLowerCase();
              if (!q) return options;
              return options.filter(
                (o) =>
                  o.code?.toLowerCase().includes(q) ||
                  o.description?.toLowerCase().includes(q),
              );
            }}
            value={selectedItemType}
            onChange={(_, selected) => {
              const newCode =
                selected?.code || DEFAULT_ITEM_CLASSIFICATION_SCHEME_ID;
              field.onChange(newCode);
              onChange?.(newCode);
            }}
            disableClearable={readOnly}
            readOnly={readOnly}
            renderOption={(props, option) => (
              <li {...props} key={option.code}>
                {option.code} - {option.description}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                sx={{ minWidth: "150px" }}
                error={!!errorMessage}
                helperText={combinedHelperText || ""}
              />
            )}
          />
        );
      }}
    />
  );
};

export default ItemClassificationSchemeIDSelect;
